module.exports = __webpack_public_path__ + "img/test1.ae6c9d0a.png";